import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "ta-c" };
const _hoisted_2 = { class: "ta-c" };
const _hoisted_3 = { class: "ta-c" };
const _hoisted_4 = { class: "title-container gap-default" };
const _hoisted_5 = {
    key: 0,
    class: "line-through brg-color-brown-200"
};
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { class: "ta-c" };
import { computed } from 'vue';
import { routeName } from '@/constants/routeName';
import dateFormatType from '@/constants/dateFormatType';
import { pStore } from '@/pinia';
import { prevData } from '@/pinia/memberCompanyInquiry';
import { isTodayTextColor, formatDate, } from '@/utils';
import { enumProcessingType, enumProcessing, enumTargetType, enumType, } from '@/constants/memberCompanyInquiry/memberCompanyInquiryTableHeader';
import { autoLcMemberCompanyInquiry } from '@/locales/ko/views/member_company_inquiry';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        const lc = autoLcMemberCompanyInquiry();
        /**
         * 링크 경로
         */
        const to = () => {
            const { id } = props.item;
            return {
                name: routeName.MEMBER_COMPANY_INQUIRY_DETAIL,
                params: {
                    memberCompanyInquiryId: id,
                },
            };
        };
        /**
         * 링크 클릭 핸들러
         */
        const handleClickLink = () => {
            // 현재 페이지네이션 번호 저장
            prevData.pageNumber = pStore.piniaMemberCompanyInquiry.filterOption.pageNumber;
        };
        /**
         * v-chip(typeClass)의 클래스 설정
         */
        const typeClass = computed(() => {
            const cssClass = {};
            switch (props.item.processingType) {
                /** 접수 */
                case enumProcessing.RECEIVED:
                    cssClass['brg-color-blue-700'] = true;
                    break;
                /** 진행 */
                case enumProcessing.IN_PROGRESS:
                    cssClass['brg-color-orange-700'] = true;
                    break;
                /** 완료 */
                case enumProcessing.DONE:
                    cssClass['brg-color-green-700'] = true;
                    break;
                /** 반려 */
                case enumProcessing.REJECTED:
                    cssClass['brg-color-red-700'] = true;
                    break;
                /** 기등록벤 */
                case enumProcessing.ALREADY_ACCEPTED_VAN:
                    cssClass['brg-color-purple-700'] = true;
                    break;
                /** 제외 */
                case enumProcessing.NO:
                    cssClass['brg-color-grey-700'] = true;
                    break;
                default:
                    cssClass['brg-color-black'] = true;
            }
            return cssClass;
        });
        /**
         * v-chip(commentClass)의 클래스 설정
         */
        const commentClass = computed(() => {
            const cssClass = {};
            cssClass['brg-color-blue-700'] = true;
            return cssClass;
        });
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_1, _toDisplayString(props.item.id), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(_unref(enumTargetType)[props.item.targetType]), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_2, [
                    _createElementVNode("span", null, [
                        _createVNode(_component_v_chip, {
                            class: _normalizeClass(typeClass.value),
                            size: "small"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(enumProcessingType)[props.item.processingType]), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["class"])
                    ])
                ]),
                _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(enumType)[props.item.type]), 1 /* TEXT */),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_4, [
                        (props.item.isDeleted)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(lc)('list.table.deleted_content')), 1 /* TEXT */))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                class: "cy-link",
                                to: to(),
                                onClick: _cache[0] || (_cache[0] = ($event) => (handleClickLink()))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(props.item.title), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["to"])),
                        (props.item.commentCount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                _createVNode(_component_v_chip, {
                                    class: _normalizeClass(commentClass.value),
                                    size: "x-small"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.item.commentCount), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("span", {
                        class: _normalizeClass(_unref(isTodayTextColor)(props.item.createdAt))
                    }, _toDisplayString(_unref(formatDate)(props.item.createdAt, _unref(dateFormatType).DATE)), 3 /* TEXT, CLASS */)
                ])
            ]));
        };
    }
});
